import classNames from "classnames";
import ChevronDownIcon from "@/components/ui/OpticksIcons/ChevronDownIcon";
import "./OpticksDropdownButton.css";
import type { OpticksDropdownButtonProps } from "../OpticksDropdown.types";

const OpticksDropdownButton = ({
  handleOpen,
  disabled,
  direction,
  behavior,
  surface,
  width = "160px",
  maxWidth,
  placeholder,
  optionSelected,
  open,
  icon,
  iconOnly = false,
}: OpticksDropdownButtonProps) => {
  return (
    <button
      type="button"
      onClick={handleOpen}
      disabled={disabled}
      className={classNames(
        "opticks-dropdown-button",
        { open: open },
        { "icon-only": iconOnly },
        { [`surface-${surface}`]: surface },
        { [`direction-${direction}`]: direction },
        { [`behavior-${behavior}`]: behavior }
      )}
      style={{ width: width, maxWidth: maxWidth || width }}
    >
      {icon && <>{icon}</>}
      <div className="label-chevron">
        {optionSelected ? (
          <span className="option-selected">{optionSelected.label}</span>
        ) : (
          <span className="placeholder">{placeholder}</span>
        )}

        {!iconOnly && <ChevronDownIcon />}
      </div>
    </button>
  );
};

export default OpticksDropdownButton;
